<template>
    <a
        :class="[
            'ui-link',
            props.color,
        ]"
        :href="href"
        :target="props.target"
    >
        <slot></slot>
    </a>
</template>

<script lang="ts" setup>
    import { defineProps, PropType } from 'vue';

    const props = defineProps({
        href: {
            type: String,
            default: '',
        },
        target: {
            type: String as PropType<'_blank' | '_self' | '_parent' | '_top'>,
            default: null,
        },
        color: {
            type: String as PropType<'white'>,
            default: null,
        },
    });
</script>

<style lang="scss" scoped>
    @use './UILink.scss' as *;
</style>
